import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=5160e2da&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=5160e2da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5160e2da",
  null
  
)

/* custom blocks */
import block0 from "./PageHeader.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports